import {GET_CheckTotal} from '../constants/ActionTypes'

const INIT_STATE = {
    GrandtotalMarks: null,
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_CheckTotal:
            console.log(action, 'actionnnn');
            return {
                GrandtotalMarks: action.body ,
                loading :false
            }
        default:
            return state;
    }
}